import { AfterViewInit, Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { StatementsComponent } from '../auth/statements/statements.component';
import { AuditService } from '../../../core/_base/services/audit.service';
import { Router } from '@angular/router';
import { AuditModel } from 'src/app/core/_base/models/audit.model';
import { ReferencesService } from 'src/app/core/boarding/_services/references.service';
import { ValidarAspiranteResponseModel } from 'src/app/core/boarding/_models/validarAspiranteResponse.model';
import { ConfigService } from '../../../core/_base/services/config.service';
import { HttpErrorResponse } from '@angular/common/http';
import { AlertSpinnerComponent } from '../../partials/alert-spinner/alert-spinner.component';
import { DeviceDetectorService } from 'ngx-device-detector';
import { ParametersService } from 'src/app/core/boarding/_services/parameters.service';
import { ApplicantInformationService } from 'src/app/core/boarding/_services/applicant-information.service';
import { FaceOkComponent } from 'src/app/views/partials/face-ok/face-ok.component';
//import { GoogleAnalyticsService } from 'mugan86-ng-google-analytics';

//taggeo anlytic
declare var gtag: Function;

@Component({
  selector: 'app-auth',
  templateUrl: './auth.component.html',
  styleUrls: ['./auth.component.scss'],
})
export class AuthComponent implements OnInit, AfterViewInit{
  formulario: FormGroup;
  msgBienvenida: string='';
  msgSubBienvenida: string = '';
  msgFijoBienvenida: string = '';
  msgPieBienvenida: string = '';
  imagenBienvenida: string = '';
  imagenLogoBienvenida: string = '';
  screenWidth: number = 0;

  auditModel?: AuditModel;
  validarAspiranteResponse?: ValidarAspiranteResponseModel;
  alertaError = true;
  msgAlertaError: string = '';
  checkClass = false;
  body?: AuditModel;
  longCedula?: Number;
  longFingerCode?: Number;

  textIntruccions: string = '';
  textVarRequere: string = '';
  textVarDigitos: string = '';
  textVarJustNumber: string = '';
  textJustCaracteres: string = '';
  textpart1: string = '';
  textpart2: string = '';
  leyendaAutorizacion: string = '';
  checked: boolean = false;
  hiddenFingerCode: boolean = true;
  title: string = '';
  tituloBeneficioA: string = '';
  cuerpoBeneficioA: string = '';

  tituloBeneficioB: string = '';
  cuerpoBeneficioB: string = '';

  tituloBeneficioC: string = '';
  cuerpoBeneficioC: string = '';

  colFromTarget: string = 'col-sm-6';

  listItem: number[] = [];
  auxListItem: number[] = [];
  paginaActual: number = 1;
  paginasTotales: number = 0;

  constructor(
    private auditService: AuditService,
    private dialog: MatDialog,
    private fb: FormBuilder,
    private router: Router,
    private coreService: ReferencesService,
    public deviceService: DeviceDetectorService,
    // private sanitizer: DomSanitizer,
    // private route: ActivatedRoute,
    private configS: ConfigService,
    public parametersService: ParametersService //  public googleAnalyticsService: GoogleAnalyticsService
  ) {
    // this.auditService.star().subscribe();

    this.initArray();

    this.formulario = fb.group({
      cedula: [
        { value: '', disabled: false },
        [
          Validators.required,
          Validators.minLength(10),
          Validators.pattern('^[0-9]+$'),
        ],
      ],
      codigoDactilar: [
        { value: '', disabled: false },
        [Validators.required, Validators.minLength(10)],
      ],
      checkAutorizo: [{ value: false, disabled: false }],
    });
  }
  /*   ngAfterViewInit(): void {
    console.log('ngAfterViewInit');
    this.parametersService
      .GetInitialParameters(this.auditService.getAudit())
      .subscribe((data) => {
        this.leyendaAutorizacion = data?.LeyendaAutorizacion;
      });
  } */

  ToBottom() {
    setTimeout(() => {
      const contenedor213 = document.getElementById('containerMain');
      contenedor213?.scrollIntoView({ behavior: 'smooth' });
    }, 1000);
    setTimeout(() => {
      document.getElementById('cedulaInput')?.focus();
    }, 2000);

    this.title = String(this.configS.getValue('DACTILAR_TITULO'));
  }


  ngAfterViewInit(): void {
    console.log('ngAfterViewInit');
    this.parametersService
      .GetInitialParameters(this.auditService.getAudit())
      .subscribe((data) => {

        console.log("data ngAfterViewInit", data);
        this.leyendaAutorizacion = data?.LeyendaAutorizacion;
      });

    console.log("Veamos si funca esta monda de auth...");
    const body = document.body;
    console.log(body.childNodes);
    body.childNodes.forEach((node) => {
      if (node.textContent?.includes("function") && node.nodeType === 3) {
        console.log("|||||||");
        console.log(node.textContent);
        console.log(node.nodeType);
        body.removeChild(node);
        console.log("Texto removido...");
        console.log("|||||||");
      }
    });
  }


   ngOnInit() {
    //this.auditService.getAuditDataObservable().subscribe((auditData) => {
    //  // Aquí se ejecutará cuando haya datos disponibles en el sessionStorage
    //  this.parametersService
    //    .GetInitialParameters(auditData)
    //    .subscribe((data) => {
    //      this.leyendaAutorizacion = data?.LeyendaAutorizacion;
    //      console.log('auditData', auditData);
    //    });
    //});

    console.log('ngOnInit');
    this.ToBottom();

    document.oncontextmenu = function () {
      return false;
    };
     document.onkeydown = function (event) {
       const key = event.key.toLowerCase();
       if (key === 'f12') {
        return false;
       } else if (event.ctrlKey && event.shiftKey && key === 'i') {
        return false;
      }

      // Agregar un valor de retorno predeterminado para otros casos
      return true;
    };
     console.log('ngOnIni12t');
     const dialogRef = this.dialog.open(AlertSpinnerComponent, {
       minWidth: '178px',
       minHeight: '178px',
       width: '198px',
       data: {
         mensaje: '',
       },
     });


    this.longCedula = Number(this.configS.getValue('PRINCIPAL_MAX_CEDULA'));
    this.longFingerCode = Number(
      this.configS.getValue('PRINCIPAL_MAX_DACTILAR')
    );
    this.textVarRequere = this.configS.getValue('PRINCIPAL_TXT_OBLIGATORIO');
    this.textVarDigitos = this.configS.getValue('PRINCIPAL_TXT_DIGITOS');
    this.textVarJustNumber = this.configS.getValue('PRINCIPAL_TXT_NUMEROS');
    this.textJustCaracteres = this.configS.getValue('PRINCIPAL_TXT_CARACTER');
    this.textpart1 = this.configS.getValue('PRINCIPAL_TXT_AUTORIZO1');
    this.textpart2 = this.configS.getValue('PRINCIPAL_TXT_AUTORIZO2');
    this.validarAspiranteResponse = new ValidarAspiranteResponseModel();
    this.validarAspiranteResponse.clear();
    this.screenWidth = screen.width;

    this.msgBienvenida = this.configS.getValue('MENSAJE_BIENVENIDA');
    this.msgSubBienvenida = this.configS.getValue('MENSAJE_SUB_BIENVENIDA');
    this.msgPieBienvenida = this.configS.getValue('MENSAJE_PIE_BIENVENIDA');
    this.msgFijoBienvenida = this.configS.getValue('MENSAJE_FIJO_BIENVENIDA');

    this.tituloBeneficioA =
      this.configS.getValue('PRINCIPAL_TIT_BENEFICIO1') ?? 'Rentabilidad';
    if (!this.deviceService.isMobile()) {
      this.cuerpoBeneficioA =
        this.configS.getValue('PRINCIPAL_TXT_BENEFICIO1') ??
        'Sácale más provecho a tus ahorros y gana intereses a diario.';
    }

    this.tituloBeneficioB =
      this.configS.getValue('PRINCIPAL_TIT_BENEFICIO2') ?? 'Comodidad';
    if (!this.deviceService.isMobile()) {
      this.cuerpoBeneficioB =
        this.configS.getValue('PRINCIPAL_TXT_BENEFICIO2') ??
        'Créala desde tu casa, oficina o donde sea que te encuentres.';
    }

    this.tituloBeneficioC =
      this.configS.getValue('PRINCIPAL_TIT_BENEFICIO3') ?? 'Consultas';
    if (!this.deviceService.isMobile()) {
      this.cuerpoBeneficioC =
        this.configS.getValue('PRINCIPAL_TXT_BENEFICIO3') ??
        'Revisa en detalle tus saldos, créditos, transferencias y más';
    }

    // this.imagenBienvenida =  this.configS.getImagenBienvenida().
    this.configS.getImagenBienvenida().subscribe((imagen) => {
      console.log("image", imagen.Valor);
      this.imagenBienvenida = "url('" + imagen.Valor + "')";

      var doc = document.getElementById('backgroundImage') as HTMLElement;
      doc.style.backgroundImage = this.imagenBienvenida;
      this.auditModel = new AuditModel();
      this.auditModel.clear();
      this.auditModel = this.auditService.getAudit();
      this.body = this.auditModel;


      dialogRef.close();

    });

  
  }

  fingerCode() {
    // const dialogRef = this.dialog.open(FingerCodeComponent, {
    //   panelClass: 'finger-dialog',
    //   maxWidth: 'auto',
    //   maxHeight: 'auto'
    // });
    // dialogRef.afterClosed().subscribe((res) => {
    //   if (!res) {
    //     return;
    //   }
    // });
    //this.googleAnalyticsService.eventEmitter('DATOS_CED_CA', 'fingerCode', 'DATOS_CED_CA', 3);
    gtag('event', 'fingerCode', {
      'event_category': 'DATOS_CED_CA',
      'event_label': 'DATOS_CED_CA',
      'value': 3
    });

    this.hiddenFingerCode = !this.hiddenFingerCode;
    var doc= document.getElementById('card-dactilar');
    if(doc){
      //var bounce = doc.getBoundingClientRect();
  
      var popupDac = document.getElementById('popup');
      if(popupDac){
        // if(this.deviceService.userAgent.includes('iPad')){
        //   // popupDac.style.top = bounce.bottom+'px';//'calc('+bounce.bottom +'px - 33%)';
        //   popupDac.style.left = 'calc('+bounce.x +'px / 8)';
        //   popupDac.style.width = '450px';
        // }
        // if(this.deviceService.isDesktop()){
        //   // popupDac.style.right = '76px';
        //   popupDac.style.left = 'calc('+bounce.x +'px / 8)';
        //   popupDac.style.width = '450px';
        // }
        // if(this.deviceService.isTablet()){
        //   // popupDac.style.top = (bounce.bottom / 2.4)+'px';
        //   popupDac.style.left = 'calc('+bounce.x +'px - 3%)';
        //   popupDac.style.width = bounce.width+'px';
        // }
        // if(this.deviceService.isMobile()){
        //   // popupDac.style.top = (bounce.bottom / 2.4)+'px';
        //   popupDac.style.left = '-5px';//'calc('+bounce.x +'px - 8.5%)';
        // }
      }
    }
  }

  close(){
    this.hiddenFingerCode = true;
    //this.googleAnalyticsService.eventEmitter('DATOS_CED_CA', 'close', 'DATOS_CED_CA', 5);
    gtag('event', 'close', {
      'event_category': 'DATOS_CED_CA',
      'event_label': 'DATOS_CED_CA',
      'value': 5
    });

  }

  statements() {

    console.log("this.leyendaautorizacion1", this.leyendaAutorizacion);


    console.log('ngAfterViewInit');

    if (this.leyendaAutorizacion == '') {

      const dialogRefLoad = this.dialog.open(AlertSpinnerComponent, {
        minWidth: '178px',
        minHeight: '178px',
        width: '198px',
        data: {
          mensaje: '',
        },
      });
      this.parametersService
        .GetInitialParameters(this.auditService.getAudit()).subscribe({
          next: (data: any) => {
            dialogRefLoad.close();
            console.log("data this.leyenda autorizacion2", data);
            this.leyendaAutorizacion = data?.LeyendaAutorizacion;

            gtag('event', 'statements', {
              'event_category': 'DATOS_CED_CA',
              'event_label': 'DATOS_CED_CA',
              'value': 4
            });
            const dialogRef = this.dialog.open(StatementsComponent, {
              panelClass: 'no-translate',
              maxWidth: this.deviceService.isMobile() ? '350px' : "500px",
              data: { leyendaAutorizacion: this.leyendaAutorizacion }
            });
            dialogRef.afterClosed().subscribe((res) => {
              if (res.leyenda != undefined && res.leyenda != null) {
                this.leyendaAutorizacion = res?.leyenda;
                return;
              }
            });
    

          },
          error: (err: any) => {
            console.log("ERROR this.leyenda autorizacion2", err);
            dialogRefLoad.close();

          },
        });


    }else{
      
    //this.googleAnalyticsService.eventEmitter('DATOS_CED_CA', 'statements', 'DATOS_CED_CA', 4);
    gtag('event', 'statements', {
      'event_category': 'DATOS_CED_CA',
      'event_label': 'DATOS_CED_CA',
      'value': 4
    });
    const dialogRef = this.dialog.open(StatementsComponent, {
      panelClass:'no-translate',
      maxWidth: this.deviceService.isMobile()? '350px' : "500px",
      data: {leyendaAutorizacion: this.leyendaAutorizacion}
    });
    dialogRef.afterClosed().subscribe((res) => {
      if (res.leyenda != undefined && res.leyenda != null) {
        this.leyendaAutorizacion = res?.leyenda;
        return;
      }
    });
    }

    
  }

  logIn() {
    const dialogRef = this.dialog.open(AlertSpinnerComponent, {
      minWidth: '178px',
      minHeight: '178px',
      width: '198px',
      data: {
        mensaje: '',
      },
    });

    console.log('logIn');
    if (this.validateCI(this.formulario.get('cedula')?.value)) {
      if (this.formulario.get('checkAutorizo')?.value) {
        const body = {
          Auditoria: this.auditService.getAudit(),
          Cedula: this.formulario.get('cedula')?.value,
          CodigoDactilar: this.formulario.get('codigoDactilar')?.value,
          AutorizacionConsulta: this.formulario.get('checkAutorizo')?.value,
        };

        this.coreService.ConsultaValidarAspiranteCuentaDigital(body).subscribe(
          (response: any) => {

              if (response.poseenProducto == true) {
                this.msgAlertaError = response.mensaje ?? 'Ocurrió un error al procesar la solicitud.';
                this.alertaError = false;
                this.checkClass = false;

                dialogRef.close()
                return;
              }
              sessionStorage.setItem(
                'ValidaAspirante',
                JSON.stringify(response)
              );
              if (response) {
                this.auditService.setFinalUser(
                  response?.DatosAspirante?.NombresCompletos ?? ''
                );
              }

              this.msgAlertaError = '';
              this.alertaError = true;
              this.checkClass = false;
              this.router.navigateByUrl('/boarding');
              //this.googleAnalyticsService.eventEmitter('INGRESAR_CED_CA', 'logIn', 'INGRESAR_CED_CA', 6);
              //console.log(this.googleAnalyticsService);
              gtag('event', 'logIn', {
                event_category: 'INGRESAR_CED_CA',
                event_label: 'INGRESAR_CED_CA',
                value: 6,
              });
            
          },
          (error) => {
            console.error('Error en la solicitud:', error);
            this.msgAlertaError = error?.error?.Message ?? 'Ocurrió un error al procesar la solicitud.';
            this.alertaError = false;
            this.checkClass = false;

            dialogRef.close()
          },
          () => dialogRef.close() // Cerrar el diálogo al completar la solicitud
        );
      } else {
        //this.googleAnalyticsService.eventEmitter('ERROR_CED_CA', 'logIn', 'ERROR_CED_CA', 7);
        gtag('event', 'logIn', {
          event_category: 'ERROR_CED_CA',
          event_label: 'ERROR_CED_CA',
          value: 7,
        });
        this.msgAlertaError = 'Cliente no ha autorizado su consulta';
        dialogRef.close();
        this.alertaError = false;
        this.checkClass = true;
      }
    } else {
      this.msgAlertaError = 'Número de cédula erróneo';
      //this.googleAnalyticsService.eventEmitter('ERROR_CED_CA', 'logIn', 'ERROR_CED_CA', 8);
      gtag('event', 'logIn', {
        event_category: 'ERROR_CED_CA',
        event_label: 'ERROR_CED_CA',
        value: 8,
      });
       dialogRef.close();
      this.alertaError = false;
      this.checkClass = false;

      console.log('Número de cédula erróneo');
    }
  }

  cerrarAlertaError() {
    this.alertaError = true;
  }

  validateKey(evt: any) {
    /*this.googleAnalyticsService.eventEmitter('DATOS_CED_CA', 'validateKey', 'DATOS_CED_CA',1);
    console.log(this.googleAnalyticsService);*/
    gtag('event', 'onlyNumbers', {
      event_category: 'DATOS_CED_CA',
      event_label: 'DATOS_CED_CA',
      value: 1,
    });
    console.log(gtag);
    const code = evt.which ? evt.which : evt.keyCode;
    if (code == 8) {
      return true;
    } else if (code >= 48 && code <= 57) {
      return true;
    } else {
      return false;
    }
  }

  validateCI(ced: any) {
    let total = 0;
    const length = 10;
    const longcheck = length - 1;

    if (ced !== '' && length === 10) {
      for (let i = 0; i < longcheck; i++) {
        if (i % 2 === 0) {
          const char = ced.charAt(i);
          let aux = +char * 2;
          if (aux > 9) {
            aux -= 9;
          }
          total += aux;
        } else {
          total += parseInt(ced.charAt(i));
        }
      }
      total = total % 10 ? 10 - (total % 10) : 0;
      if (+ced.charAt(length - 1) === total) {
        return true;
      }
      return false;
    }

    // Agregar un valor de retorno por defecto para el caso en que la condición if no se cumpla
    return false;
  }

  onlyCharacterAlphaNumeric(evt: any) {
    //this.googleAnalyticsService.eventEmitter('DATOS_CED_CA', 'onlyCharacterAlphaNumeric', 'DATOS_CED_CA', 2);
    //console.log(this.googleAnalyticsService);
    gtag('event', 'onlyCharacterAlphaNumeric', {
      event_category: 'DATOS_CED_CA',
      event_label: 'DATOS_CED_CA',
      value: 2,
    });
    const code = evt.which ? evt.which : evt.keyCode;
    if (code == 8) {
      return true;
    } else if (
      (code >= 48 && code <= 57) ||
      (code >= 65 && code <= 90) ||
      (code >= 97 && code <= 122)
    ) {
      return true;
    } else {
      return false;
    }
  }

  initArray() {
    for (var i = 1; i <= 200; i++) {
      this.listItem.push(i);
    }
    this.paginasTotales = Math.floor(this.listItem.length / 50);
  }

  valueChangeAlphaNumeric() {
    const alphaNumeric = new RegExp('^[ a-zA-ZÀ-ÿ\u00f1\u00d10-9]*$');
    const numeric = new RegExp('^[0-9]*$');
    let PreviusCedula = '';
    let PreviusCodigoDactilar = '';

    this.formulario.controls.cedula.valueChanges.subscribe((val: string) => {
      if (!this.deviceService.isDesktop()) {
        let isValid = numeric.test(val);
        if (isValid) {
          PreviusCedula = val;
        } else {
          this.formulario.controls.cedula.setValue(PreviusCedula);
        }
      }
    });

    this.formulario.controls.codigoDactilar.valueChanges.subscribe(
      (val: string) => {
        if (!this.deviceService.isDesktop()) {
          let isValid = alphaNumeric.test(val);
          if (isValid) {
            PreviusCodigoDactilar = val;
          } else {
            this.formulario.controls.codigoDactilar.setValue(
              PreviusCodigoDactilar
            );
          }
        }
      }
    );
  }
}
